import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from "@tanstack/react-query";
import { App } from "antd";
import { handleError } from "api";
import {
  EventsParams,
  eventsQueryKeys,
  EventsResponse,
} from "features/events";
import { TransectionApiServices } from "../api/transection-api.service";

const { getUploadDetails } = TransectionApiServices();


// 🔹 Build query config
const getEventsQuery = (
  params: EventsParams,
  origin: string,
  options?: UseQueryOptions<EventsResponse>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<EventsResponse>;
} => ({
  // ✅ include origin in cache key
  queryKey: [...eventsQueryKeys.list(params), origin],

  // ✅ FIXED argument order here
  queryFn: ({ signal }) =>
    getUploadDetails(
      params,
      { config: { signal } },   // 2nd param = callConfig
      origin                   // 3rd param = origin
    ),

  ...options,
});


// 🔹 Custom Hook
export const useGetUploadDetails = (
  params: EventsParams,
  origin: string,
  options?: UseQueryOptions<EventsResponse>,
) => {
  const { message } = App.useApp();

  return useQuery<EventsResponse, Error>(
    getEventsQuery(params, origin, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);
        message.error(uiMessage);
      },
      ...options,
    }),
  );
};